import UFOSegment from './segment';
export default UFOSegment;